// Dependencies
import React from 'react';
import radium from 'radium';
import CheckoutButtons from "../CheckoutButtons";
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import ZigZagBox from "../../../components/zig-zag-box/ZigZagBox";

function PP_ERROR(props) {
	const context = React.useContext(ThemeContext)
	const style = {
		container: {
			width: '100%',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	let errorTextKey = 'ppErrorText';
	if (props.checkoutProps.output && props.checkoutProps.output.errorType) {
		const errorTypeTextKey = props.checkoutProps.output.errorType.charAt(0).toUpperCase() + props.checkoutProps.output.errorType.slice(1).toLowerCase()
		errorTextKey += errorTypeTextKey
	}

	return (
		<div style={style.container}>
			<h1 className="page__headline"
				dangerouslySetInnerHTML={{
					__html: context.themeManager
						.getThemeTextOrHardcodedDefault('ppErrorHeadline'),
				}}
			/>
			<ZigZagBox>
				<div style={style.error}
					dangerouslySetInnerHTML={{__html: context.themeManager.getThemeTextOrHardcodedDefault(errorTextKey),}}/>
			</ZigZagBox>
			<CheckoutButtons
				btnResetLabel={props.btnLabels.resetBtnLabel || context.themeManager.getThemeTextOrHardcodedDefault('backToSCBtnLabel')}
				onResetClick={()=>props.reset({method: props.checkoutProps.method, provider: props.checkoutProps.provider})}
				hideNextButton={true}
				hideBackButton={true}
				btnResetStyle={'highlight'}
			/>
		</div>
	);
}
const RadiumPP_ERROR = radium(PP_ERROR);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumPP_ERROR.name = PP_ERROR.name
export default RadiumPP_ERROR;
